import { Component } from '@angular/core';
import { NavController, NavParams, LoadingController } from 'ionic-angular';
import { Broadcaster } from '../../app/broadcaster';
import { Storage } from '@ionic/storage';
import { ApiService } from '../../app/services/api.service';
import { Config } from '../../app/app.config';
import { OkageStorageProvider } from '../../providers/okage-storage/okage-storage';

@Component({
  selector: 'page-rmd',
  templateUrl: 'recommend.html'
})
export class RecommendPage {

  foods: Array<Array<{id: number, title: string, desc: string, thumb: string, price: number, like: number, liked: boolean}>>;
  items: Array<{id: number, title: string, desc: string, thumb: string, price: number, like: number, liked: boolean, aIndex: number, iIndex: number}>;
  iFoods: Array<Array<number>>;
  iTotal: number;
  loading: any;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private broadcaster: Broadcaster,
    private _apiService: ApiService,
    private _okageStorage: OkageStorageProvider,
    private loadingCtrl: LoadingController) {
    
    this.loading = this.loadingCtrl.create();
    this.foods = [];
    this.iFoods = [];
    this.items = [];

    this.loading.present();
    this._apiService.getRankingList(4).subscribe(
      (result) => {
      this.loading.dismiss();
      if ( result.status == 1000 && result.content.length) {
        this.foods = [];
        //console.log("result this.foods: " + JSON.stringify(this.foods));
        for (var i = 0; i < result.content.length; i++) {
          for (var j = 0; j < result.content[i].length; j++) {
            this.items.push({
              id: result.content[i][j].id,
              title:result.content[i][j].title,
              desc: result.content[i][j].desc,
              thumb: result.content[i][j].thumb,
              price: result.content[i][j].price,
              like: result.content[i][j].like,
              liked: false,
              aIndex: -1,
              iIndex: -1
            });
          }
        }
        this.storage.get('foods.menu').then((m) => {
          for (var i = 0; i < m.length; i++) {
            for (var j = 0; j < m[i].length; j++) {
              for (var k = 0; k < this.items.length; k ++) {
                if (this.items[k].id == m[i][j].id) {
                  this.items[k].aIndex = i;
                  this.items[k].iIndex = j;
                  this.items[k].like = m[i][j].like;
                  this.items[k].liked = m[i][j].liked;
                  if (!this.foods[i]) {
                    this.foods[i] = [];
                  }
                  this.foods[i][j] = this.items[k];
                  break;
                }
              }
            }
          }
          this.foodCounterChanged();
        });
      }

    }, error => {
        console.log(error);
        this.loading.dismiss();
    });

    this.broadcaster.on<number>('foodCounterChanged')
      .subscribe(from => {
        if (from != 3) {
          this.foodCounterChanged();
        }
      });
    
    this.broadcaster.on<number>('foodLikeChanged')
      .subscribe(from => {
          console.log("fooldLikeChanged");
          console.log(from);
        if (from != 3) {
          this.foodLikeChanged();
        }
      });
  }

  foodCounterChanged() {
    this.iFoods = [];
    this.iTotal = 0;
    this.storage.get('foods.selected').then((v) => {
      if (v) {
        this.iFoods = v;
      }
      this.countTotal();
    });
  }

  foodLikeChanged() {
    console.log('go like changed recommend');
    this.storage.get('foods.menu').then((m) => {
      if (m) {
        this.foods = m;
        for (var i = 0; i < this.foods.length; i++) {
          for (var j = 0; j < this.foods[i].length; j++) {
            for (var k = 0; k < this.items.length; k++) {
              if (this.items[k].id == this.foods[i][j].id) {
                this.items[k].like = this.foods[i][j].like;
                this.items[k].liked = this.foods[i][j].liked;
                break;
              }
            }
          }
        }
      }
    });
  }

  chooseFood(aIndex, iIndex) {
    if (!this.iFoods[aIndex]) {
      this.iFoods[aIndex] = [];
    }
    if (!this.iFoods[aIndex][iIndex]) {
      this.iFoods[aIndex][iIndex] = 0;
    }
    this.iFoods[aIndex][iIndex]++;
    this.storage.set('foods.selected', this.iFoods).then((a) => {
      this.countTotal();
      this.broadcaster.broadcast('foodCounterChanged', 3);
    });
  }

  removeFood(aIndex, iIndex) {
    if (!this.iFoods[aIndex][iIndex]) {
      return;
    }
    this.iFoods[aIndex][iIndex]--;
    this.storage.set('foods.selected', this.iFoods).then((a) => {
      this.countTotal();
      this.broadcaster.broadcast('foodCounterChanged', 3);
    });
  }

  private countTotal() {
    var total = 0;
    for(var i = 0; i < this.iFoods.length; i++) {
      if (this.iFoods[i]) {
        for(var j = 0; j < this.iFoods[i].length; j++) {
          if (this.iFoods[i][j]) {
            total += this.iFoods[i][j];
          }
        }
      }
    }
    this.iTotal = total;
    this.storage.set('iTotal', this.iTotal);
  }

  like(aIndex, iIndex, itemIndex) {
    if (!this.foods[aIndex][iIndex].liked) {
      this.foods[aIndex][iIndex].liked = true;
      this.foods[aIndex][iIndex].like++;
      this.items[itemIndex].liked = this.foods[aIndex][iIndex].liked;
      this.items[itemIndex].like = this.foods[aIndex][iIndex].like;
      this.storage.get('foods.menu').then((ms) => {
        if (ms) {
          for (var i = 0; i < ms.length; i++) {
            for (var j = 0; j < ms[i].length; j++) {
              if (ms[i][j].id == this.items[itemIndex].id) {
                ms[i][j].liked = this.items[itemIndex].liked;
                ms[i][j].like = this.items[itemIndex].like;
                break;
              }
            }
          }
          
          this.storage.set('foods.menu', ms).then((a) => {
            this.broadcaster.broadcast('foodLikeChanged', 3);
            this._apiService.like(this.items[itemIndex].id).subscribe(
            (result) => {
              console.log(result);
            });
          });
        }
      });
    } else {
      this.foods[aIndex][iIndex].liked = false;
      this.foods[aIndex][iIndex].like--;
      this.items[itemIndex].liked = this.foods[aIndex][iIndex].liked;
      this.items[itemIndex].like = this.foods[aIndex][iIndex].like;
      this.storage.get('foods.menu').then((ms) => {
        if (ms) {
          for (var i = 0; i < ms.length; i++) {
            for (var j = 0; j < ms[i].length; j++) {
              if (ms[i][j].id == this.items[itemIndex].id) {
                ms[i][j].liked = this.items[itemIndex].liked;
                ms[i][j].like = this.items[itemIndex].like;
                break;
              }
            }
          }
          
          this.storage.set('foods.menu', ms).then((a) => {
            this.broadcaster.broadcast('foodLikeChanged', 3);
            this._apiService.unlike(this.items[itemIndex].id).subscribe(
            (result) => {
              console.log(result);
            });
          });
        }
      });
    }
  }

  sendOrder() {
    // send order page
    this.navCtrl.parent.select(Config.tab_menu_number.sendorderpage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/recommend/recommend.ts